/* Northern Ridge: second-shipment fee (2026-10-14, approved by Arik).
   A cart with at least one FALL plant and at least one SPRING plant ships in two boxes, so a "Second shipment fee"
   line (window.NRNShip2.variant, $9.95) is kept in the cart. It is waived when each season's plants total
   >= window.NRNShip2.waive (cents, $75) on their own, because then each box would ship free anyway.
   Rules: added when needed, removed when not, re-added if a shopper deletes it, quantity pinned to 1.
   Runs on every page load and after every cart change made through fetch (theme, cart page, quick add, apps).
   Also exposes NRNShip2.moveAll('fall'|'spring') for the cart page "ship everything together" buttons. */
(function () {
  var C = window.NRNShip2; if (!C || !C.variant) return;
  var FEE = +C.variant, WAIVE = +C.waive || 7500, running = false, again = false;
  var nativeFetch = window.fetch.bind(window);
  var J = { 'Content-Type': 'application/json', Accept: 'application/json', 'X-NRN-Ship2': '1' };

  function seasonOf(item) {
    var t = String(item.variant_title || '') .toUpperCase();
    if (/NOV|FALL/.test(t)) return 'fall';
    if (/MAR|SPRING/.test(t)) return 'spring';
    return '';
  }
  function state(cart) {
    var s = { fall: 0, spring: 0, fallN: 0, springN: 0, feeQty: 0, feeKey: null };
    (cart.items || []).forEach(function (it) {
      if (it.variant_id === FEE) { s.feeQty += it.quantity; s.feeKey = it.key; return; }
      var se = seasonOf(it); if (!se) return;
      s[se] += it.final_line_price; s[se + 'N'] += it.quantity;
    });
    s.mixed = s.fallN > 0 && s.springN > 0;
    s.want = s.mixed && !(s.fall >= WAIVE && s.spring >= WAIVE);
    return s;
  }
  function getCart() { return nativeFetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }
  function post(url, body) {
    return nativeFetch(url, { method: 'POST', credentials: 'same-origin', headers: J, body: JSON.stringify(body) }).then(function (r) { return r.json(); });
  }
  function bubble() {
    return nativeFetch('/?sections=cart-icon-bubble', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (j) {
      var b = document.getElementById('cart-icon-bubble'); if (!b || !j['cart-icon-bubble']) return;
      var t = document.createElement('div'); t.innerHTML = j['cart-icon-bubble']; var inner = t.querySelector('.shopify-section') || t; b.innerHTML = inner.innerHTML;
    }).catch(function () {});
  }
  function sync() {
    if (running) { again = true; return Promise.resolve(); }
    running = true;
    return getCart().then(function (cart) {
      var s = state(cart), job = null;
      if (s.want && s.feeQty === 0) job = post('/cart/add.js', { items: [{ id: FEE, quantity: 1 }] });
      else if (s.want && s.feeQty !== 1) job = post('/cart/change.js', { id: s.feeKey, quantity: 1 });
      else if (!s.want && s.feeQty > 0) job = post('/cart/change.js', { id: s.feeKey, quantity: 0 });
      window.NRNShip2.state = s;
      if (!job) return false;
      return job.then(function () { return true; });
    }).then(function (changed) {
      running = false;
      var pr = null;
      if (changed) {
        bubble();
        if (typeof window.NRNCartRefresh === 'function') pr = window.NRNCartRefresh();
        document.dispatchEvent(new CustomEvent('nrn:ship2-changed'));
      }
      return Promise.resolve(pr).then(function () { if (again) { again = false; return sync(); } });
    }).catch(function () { running = false; });
  }

  /* re-check after any cart mutation made with fetch (skip our own calls) */
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = nativeFetch(input, init);
    var mine = init && init.headers && (init.headers['X-NRN-Ship2'] || (init.headers.get && init.headers.get('X-NRN-Ship2')));
    if (!mine && /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url)) p.then(function () { setTimeout(sync, 50); }, function () {});
    return p;
  };
  /* classic form posts (noscript / app forms) reload the page, so the load-time sync covers them */

  /* move every plant to one season (cart page buttons) */
  window.NRNShip2.moveAll = function (target) {
    var want = target === 'fall' ? /NOV|FALL/ : /MAR|SPRING/;
    return getCart().then(function (cart) {
      var moves = cart.items.filter(function (it) { return it.variant_id !== FEE && seasonOf(it) && seasonOf(it) !== target; });
      return Promise.all(moves.map(function (it) {
        return nativeFetch('/products/' + it.handle + '.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (p) {
          var keep = (it.variant_options || []).filter(function (o) { return !/SHIPPING|NOV|MAR|FALL|SPRING/i.test(o); });
          var v = (p.variants || []).filter(function (v) {
            return v.available && want.test(String(v.title).toUpperCase()) && keep.every(function (o) { return v.options.indexOf(o) !== -1; });
          })[0];
          return v ? { from: it.key, to: v.id, qty: it.quantity, props: it.properties || {} } : { from: it.key, to: null };
        });
      }));
    }).then(function (plan) {
      var ok = plan.filter(function (m) { return m.to; }), miss = plan.length - ok.length;
      if (miss) return { moved: 0, missed: miss };   /* never half-move a cart: all or nothing */
      if (!ok.length) return { moved: 0, missed: 0 };
      return post('/cart/add.js', { items: ok.map(function (m) { return { id: m.to, quantity: m.qty, properties: m.props }; }) }).then(function (res) {
        if (res && res.status && res.status >= 400) throw res;
        var up = {}; ok.forEach(function (m) { up[m.from] = 0; });
        return post('/cart/update.js', { updates: up });
      }).then(function () { return { moved: ok.length, missed: miss }; });
    }).then(function (r) {
      return sync().then(function () { return typeof window.NRNCartRefresh === 'function' ? window.NRNCartRefresh() : null; }).then(function () { return r; });
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync); else sync();
  window.addEventListener('pageshow', function (e) { if (e.persisted) sync(); });
})();
